<template>
  <div>
    <div>
      <el-button
        v-if="shareData.isShowBtnAndFields"
        :disabled="false"
        class="vg_mb_8"
        size="small"
        type="warning"
        @click="contractPreview()"
        >合同预览</el-button
      >
      <!--<el-button :disabled="isShow" class="vg_mb_8" size="small" type="primary" @click="synchronizeEMS()">同步EMS</el-button>-->
      <div v-if="$cookies.get('userInfo').acct_id === 1">
        <el-button :disabled="false" class="vg_mb_8" size="small" type="danger" @click="invalid()">失效</el-button>
        <!--<el-button :disabled="false" class="vg_mb_8" size="small" type="success" @click="dispatch()">下发</el-button>-->
        Tips: 任何操作后不可撤销,请核对后再进行操作!
      </div>
    </div>
    <DynamicUTable
      ref="dynamicUTable"
      :columns="c_subTableProperties"
      :computed-data="{}"
      :is-show="isShow"
      :max-height="400"
      :need-pagination="false"
      :row-click="(row, column, event) => (currentRow = row)"
      :show-summary="true"
      :summaries-columns="['total_purchase_price', 'lossy_quantity']"
      :tableData="subTableData"
    >
      <template v-slot:purchase_type_deta="scope">
        <span :style="{ color: scope.row.purchase_type_deta === '补料' ? 'red' : 'inherit' }">{{ scope.row.purchase_type_deta }}</span>
      </template>
      <template v-slot:operation="scope">
        <el-button size="mini" type="primary" @click="dialogVisible = true"> 生成二维码 </el-button>
        <el-button size="mini" type="primary" @click="dialogVisible2 = true"> 查看 </el-button>
      </template>
    </DynamicUTable>
    <el-dialog :visible.sync="dialogVisible" title="生成二维码" top="0" width="30%">
      <div v-loading="loading">
        <DynamicForm
          ref="dynamicForm"
          :computed-data="{ quantity_total }"
          :form-list="c_formProperties"
          class="dynamicForm"
          v-bind="$attrs"
        />
        <div class="vg_mb_8" style="display: flex">
          <el-button size="small" type="primary" @click="dialogConfirm('单张生成')">单次生成</el-button>
          <el-button size="small" type="primary" @click="dialogConfirm('批量生成')">批量生成</el-button>
          <el-button size="small" type="info" @click="dialogVisible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="打印预览二维码" top="0" width="50%" @opened="getDialogData2">
      <div class="vg_mb_8" style="display: flex">
        <el-button size="small" type="primary" @click="printSeparately">单独打印</el-button>
        <el-button size="small" type="info" @click="batchPrinting">批量打印</el-button>
      </div>
      <el-carousel
        @change="val => (currentIndex = val)"
        arrow="always"
        height="800px"
        indicator-position="outside"
        trigger="click"
        :autoplay="false"
      >
        <el-carousel-item v-for="(item, index) in imageList" :key="index">
          <el-image :src="item.qrcode_url" fit="contain" style="width: 100%; height: 100%">
            <template #error>
              <div class="image-slot" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center">
                <span>图片加载失败</span>
              </div>
            </template>
          </el-image>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>
<script>
import DynamicUTable from '@/components/table/DynamicUTable.vue';
import DynamicForm from '@/components/DynamicFormV2.vue';
import { cloneDeep } from 'lodash';
import { dialogformProperties, subTableProperties } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/properties';
import printJS from 'print-js';
import { keepNDecimal } from '@assets/js/regExUtil';
import { BigNumber } from 'bignumber.js';
import { api } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/api';

export default {
  name: 'FinishedProductAndMaterialOrderSubTable',
  components: { DynamicUTable, DynamicForm },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  inject: ['shareData'],
  data() {
    return {
      subTableData: [],
      subTableProperties: cloneDeep(subTableProperties),
      currentRow: {},
      dialogVisible: false,
      dialogVisible2: false,
      dialogformProperties: cloneDeep(dialogformProperties),
      currentIndex: 0,
      imageList: [],
      loading: false
    };
  },
  watch: {
    c_subTableProperties(newValue, oldValue) {
      this.$nextTick(() => {
        this.$refs.dynamicUTable.refreshColumn();
      });
    }
  },
  computed: {
    c_formProperties() {
      this.dialogformProperties.forEach(item => {
        item.model = this.currentRow[item.prop];
        if (item.prop === 'quantity') {
          item.model = this.quantity_total;
          item.input = (list, index, val) => {
            list[index].model = keepNDecimal(val, 2);
            // if (list[index].model > Number(this.quantity_total)) {
            //   list[index].model = this.quantity_total;
            // }
          };
        }
      });
      return this.dialogformProperties;
    },
    c_subTableProperties() {
      this.subTableProperties.forEach(item => {
        switch (item.prop) {
          case 'purchase_unit_price':
          case 'total_purchase_price':
            item.visible = this.shareData.isShowBtnAndFields;
            break;
        }
      });
      return this.subTableProperties;
    },
    quantity_total() {
      let { lossy_quantity, residue_num } = this.currentRow;
      let temp = new BigNumber(lossy_quantity).minus(residue_num);
      if (!temp.isFinite()) {
        this.currentRow.quantity_total = 0;
        return 0;
      }
      this.currentRow.quantity_total = temp.toFixed(2);
      return temp.toFixed(2);
    }
    // net_weight() {
    //   let quantity = this.dialogformProperties.find(x => x.prop === 'quantity').model;
    //   let { prod_unit, net_weight, outer_packaging_quantity, gram_weight, width } = this.currentRow;
    //   if (prod_unit === '米') {
    //     let temp = new BigNumber(gram_weight).times(width).times(quantity).div(1000);
    //     if (!temp.isFinite()) {
    //       return 0;
    //     }
    //     return temp.toFixed(2);
    //   } else {
    //     let temp = new BigNumber(quantity).div(outer_packaging_quantity).times(net_weight);
    //     if (!temp.isFinite()) {
    //       return 0;
    //     }
    //     return temp.toFixed(2);
    //   }
    // }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {},
    contractPreview() {
      window.open(this.shareData.file_address);
      //downloadFile({ fileUrl: this.shareData.file_address, open: true });
    },
    synchronizeEMS() {},
    invalid() {
      let formData = new FormData();
      formData.append('purmaterial_orders_id', this.shareData.purmaterial_orders_id);
      api.order_becomes_invalid(formData).then(({ data }) => {
        this.$message.success('失效成功');
      });
    },
    dispatch() {
      let formData = new FormData();
      formData.append('purmaterial_orders_id', this.shareData.purmaterial_orders_id);
      api.order_issuance(formData).then(({ data }) => {
        this.$message.success('下发成功');
      });
    },
    dialogConfirm(type) {
      // if (this.quantity_total <= 0) {
      //   this.$message.warning('数量不足!');
      //   return;
      // }
      let formModel = this.$refs.dynamicForm.getFormModel();
      if (!formModel.net_weight || formModel.net_weight === 0) {
        this.$message.warning('请输入净重!');
        return;
      }
      formModel.source_attribute = '进口物料';
      formModel.association_id = this.currentRow.rmatercontract_details_id;
      formModel.cdc_customs_name = this.currentRow.cdc_customs_name;
      formModel.cdc_number = this.currentRow.cdc_number;
      formModel.generate_attribute = type;
      formModel.order_no = this.shareData.purmaterial_orders_no;
      this.loading = true;
      api.generateQRCode(formModel).then(({ data }) => {
        this.$emit('refreshData');
        this.$message.success('生成成功');
        this.dialogVisible = false;
        this.loading = false;
      });
    },
    getDialogData2() {
      let formModel = {};
      formModel.source_attribute = '进口物料';
      formModel.association_id = this.currentRow.rmatercontract_details_id;
      api.getQRCodeList(formModel).then(({ data }) => {
        this.imageList = data.list;
      });
    },
    // 单独打印 - 打印当前选中的图片
    printSeparately() {
      if (this.imageList.length === 0) {
        this.$message.warning('没有可打印的图片');
        return;
      }
      this.print([this.imageList[this.currentIndex]]);
    },
    // 批量打印 - 打印所有图片
    batchPrinting() {
      if (this.imageList.length === 0) {
        this.$message.warning('没有可打印的图片');
        return;
      }
      this.print(this.imageList);
    },
    print(list) {
      printJS({
        printable: list.map(x => x.qrcode_url),
        type: 'image',
        imageStyle: ' width: 100%; height: 100%; object-fit: fill;',
        style: '@page { size: 7.6cm 13.0cm; margin: 0; padding: 0; }'
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
